<div class="modal locationPermission d-block" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <img src="../../../assets/nps-location.svg" alt="">
        </div>
        <div class="modal-body">
         <h1>test</h1>
         <p>test</p>
         <button class="continue-btn" type="button">test</button>
         <a [routerLink]="" fragment="iOSInstructions">test<img src="../../../../assets/polygon.svg" alt=""></a>
        </div>
      </div>
    </div>
</div>
